import { App } from '../work-modules/037/App';

const main = async () => {
  const video = document.getElementById("videoCamera") as HTMLVideoElement;
  const poseCanvas = document.getElementById("pose-canvas") as HTMLCanvasElement;
  const particleCanvas = document.getElementById("particle-canvas") as HTMLCanvasElement;

  if (video && poseCanvas && particleCanvas) {
    const app = new App(video, poseCanvas, particleCanvas);
    try {
      await app.initialize();
    } catch (error) {
      console.error("Failed to initialize application:", error);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  main();
});